var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":"抽取记录","visible":_vm.historyVisible,"width":"80%"},on:{"cancel":function($event){return _vm.$emit('cancel')},"ok":function($event){return _vm.$emit('success')}}},[_c('record-s-table',{attrs:{"recordVisible":_vm.historyVisible,"columns":_vm.columns,"readOnly":_vm.readOnly,"expertId":_vm.expertId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }